import { getTvObject, tv } from '@costar-ui/cosmos';

var logoTV = getTvObject({
  base: ['border', 'border-neutral', 'rounded'],
  //base = common styles
  variants: {
    size: {
      xs: ['w-[2.625rem]', 'h-[2.625rem]', 'min-w-[2.625rem]'],
      // 42px
      sm: ['w-[5.625rem]', 'h-[5.625rem]', 'min-w-[5.625rem]'],
      // 90px
      lg: ['w-[10rem]', 'h-[10rem]', 'min-w-[10rem]'] // 160px
    }
  }
});
var base = {
  base: tv(logoTV)
};
var logoStyles = {
  base: base
};

export { logoStyles, logoTV };
//# sourceMappingURL=logo.styles.esm.js.map
